import React from 'react';
import { motion } from 'framer-motion';
import './Floating3DShapes.css';

function Floating3DShapes() {
  const shapes = [
    {
      id: 1,
      type: 'sphere',
      size: 140,
      top: '8%',
      left: '3%',
      delay: 0,
      duration: 8,
    },
    {
      id: 2,
      type: 'torus',
      size: 120,
      top: '15%',
      right: '5%',
      delay: 1,
      duration: 10,
    },
    {
      id: 3,
      type: 'cube',
      size: 100,
      bottom: '30%',
      left: '5%',
      delay: 2,
      duration: 9,
    },
    {
      id: 4,
      type: 'ring',
      size: 160,
      top: '40%',
      right: '3%',
      delay: 0.5,
      duration: 11,
    },
    {
      id: 5,
      type: 'pyramid',
      size: 110,
      bottom: '40%',
      right: '10%',
      delay: 1.5,
      duration: 8,
    },
    {
      id: 6,
      type: 'sphere',
      size: 90,
      top: '60%',
      left: '2%',
      delay: 2.5,
      duration: 7,
    },
    {
      id: 7,
      type: 'ring',
      size: 80,
      bottom: '20%',
      right: '18%',
      delay: 1,
      duration: 9,
    },
    {
      id: 8,
      type: 'cube',
      size: 70,
      top: '70%',
      left: '12%',
      delay: 3,
      duration: 8,
    },
    {
      id: 9,
      type: 'sphere',
      size: 60,
      top: '35%',
      left: '20%',
      delay: 1.2,
      duration: 7,
    },
    {
      id: 10,
      type: 'torus',
      size: 85,
      bottom: '50%',
      right: '25%',
      delay: 2.2,
      duration: 9,
    },
    {
      id: 11,
      type: 'ring',
      size: 75,
      top: '80%',
      left: '25%',
      delay: 0.8,
      duration: 10,
    },
    {
      id: 12,
      type: 'cube',
      size: 65,
      bottom: '10%',
      right: '30%',
      delay: 1.8,
      duration: 8,
    },
    {
      id: 13,
      type: 'pyramid',
      size: 55,
      top: '50%',
      left: '30%',
      delay: 2.8,
      duration: 7,
    },
    {
      id: 14,
      type: 'sphere',
      size: 50,
      bottom: '60%',
      right: '35%',
      delay: 1.5,
      duration: 6,
    },
  ];

  const floatVariants = {
    float: {
      y: [0, -30, 0],
      x: [0, 15, 0],
      rotate: [0, 10, 0],
      transition: {
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <div className="floating-3d-shapes">
      {shapes.map((shape) => (
        <motion.div
          key={shape.id}
          className={`floating-3d-shape floating-3d-shape--${shape.type}`}
          style={{
            width: `${shape.size}px`,
            height: `${shape.size}px`,
            top: shape.top,
            bottom: shape.bottom,
            left: shape.left,
            right: shape.right,
          }}
          variants={floatVariants}
          animate="float"
          transition={{
            delay: shape.delay,
            duration: shape.duration,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
}

export default Floating3DShapes;
